/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { HydratedRouteInterface } from '../../types/routes';
import { PasswordResetRedirect } from './password-reset/PasswordResetRedirect';

export const passwordResetRedirectRoute: HydratedRouteInterface = {
  id: 'passwordReset',
  label: 'Password Reset',
  path: '/password-reset',
  exact: true,
  component: PasswordResetRedirect,
};
